import axios from "axios";
import qs from "qs";
import cookie from "react-cookies";

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
const API_URL_SPEECHACE = process.env.REACT_APP_API_URL_SPEECHACE;

const API_URL = process.env.REACT_APP_API_URL;
const API_URL_PROGRESS_TRACKER = process.env.REACT_APP_API_URL_PROGRESS_TRACKER;
const API_URL_WIZ_SPEECH = process.env.REACT_APP_API_URL_WIZ_SPEECH;

const SELF_LEARNING_BFF_URL = process.env.REACT_APP_SELF_LEARNING_BFF_URL;
const TAAS_AUTH_KEY = process.env.REACT_APP_TAAS_AUTH_KEY;

const cmsNoPrefix = axios.create({
  baseURL: `${API_URL}/`,
  timeout: 20000,
});

const cms = axios.create({
  baseURL: `${API_URL}/wizme_api/v1/`,
  timeout: 25000,
});

const apiSpeechace = axios.create({
  baseURL: `${API_URL_SPEECHACE}/v1/`,
  timeout: 25000,
});

const progressTracker = axios.create({
  baseURL: `${API_URL_PROGRESS_TRACKER}/`,
  timeout: 25000,
});

const apiWizSpeech = axios.create({
  baseURL: `${API_URL_WIZ_SPEECH}/`,
  timeout: 30000,
});

const selfLearningBff = axios.create({
  baseURL: `${SELF_LEARNING_BFF_URL}/`,
  timeout: 20000,
});

export function createMetrics(data, tenant) {
  return progressTracker({
    method: "POST",
    url: `/v1/metrics/${tenant}`,
    data: data,
  });
}

export function updateMetrics(data, tenant) {
  return progressTracker({
    method: "PATCH",
    url: `/v1/metrics/${tenant}`,
    data: data,
  });
}

export function getMetrics(userId, exerciseId, tenant) {
  return progressTracker({
    method: "GET",
    url: `/v1/metrics/${tenant}/${userId}/${exerciseId}`,
  });
}

export function getMetricsV2(userId, exerciseId, tenant) {
  return progressTracker({
    method: "GET",
    url: `/v2/metrics/${tenant}/${userId}/${exerciseId}`,
  });
}

export function createUsage(data, tenant) {
  return progressTracker({
    method: "POST",
    url: `/usage/${tenant}`,
    data: data,
  });
}

export function updateUsage(data, tenant) {
  return progressTracker({
    method: "PATCH",
    url: `/usage/${tenant}`,
    data: data,
  });
}

export function getUsage(userId, lessonId, tenant) {
  return progressTracker({
    method: "GET",
    url: `/usage/${tenant}/${userId}/${lessonId}`,
  });
}

export function getUsageV2(platformId, lessonId, tenant) {
  return progressTracker({
    method: "GET",
    url: `/v2/usage/${tenant}/${platformId}/${lessonId}`,
  });
}

export function registerCompleteness(data, tenant) {
  return progressTracker({
    method: "POST",
    url: `/completeness-books/${tenant}`,
    data: data,
  });
}

export function getCompleteness(userId, batchId, tenant) {
  return progressTracker({
    method: "GET",
    url: `/completeness-books/${tenant}/${userId}/${batchId}`,
  });
}

export function getCompletenessV2(platformId, batchId, tenant) {
  return progressTracker({
    method: "GET",
    url: `/v2/completeness-books/${tenant}/${platformId}/${batchId}`,
  });
}

export function getCompletenessPercentageByBook(
  tenant,
  userId,
  bookId,
  totalLessonsCount = 0,
) {
  return progressTracker({
    method: "GET",
    url: `/completeness-books/${tenant}/${userId}/book/${bookId}?totalLessons=${totalLessonsCount}`,
  });
}

export function getCompletenessPercentageByBookV2(
  tenant,
  platformId,
  bookId,
  totalLessonsCount = 0,
) {
  if (!totalLessonsCount) return;
  return progressTracker({
    method: "GET",
    url: `/v2/completeness-books/${tenant}/${platformId}/book/${bookId}?totalLessons=${totalLessonsCount}`,
  });
}

export function getLanguagePack() {
  let data = localStorage.getItem("languagePack");

  return data == null ? {} : JSON.parse(data);
}

export async function loginManager(
  data,
  loginService = login,
  getUserService = getUser,
) {
  try {
    const session = await loginService(data);

    await setToken(session);
    cookie.save("last_login", new Date().toJSON(), { path: "/" });

    let user = await getUserService();

    localStorage.setItem("user-info", JSON.stringify(user));

    return {
      token: session,
      user,
    };
  } catch (error) {
    throw error;
  }
}

export function getCodeForQr() {
  return cms({
    method: "GET",
    url: "/qrcode/hash/",
  });
}

export async function setToken(data) {
  try {
    let stringifiedToken = JSON.stringify(data);
    setHeader(data.token_type, data.access_token);
    cookie.save("token_info", stringifiedToken, { path: "/" });
    return data;
  } catch (e) {
    throw {
      status: "storage",
      message: "Problema ao armazenar o token: " + JSON.stringify(e),
    };
  }
}

// get pre e post video do cadastro do CMS - inicio
export async function getPrePostVideo(lessonId) {
  return cms({
    method: "GET",
    url: `/lessons/${lessonId}/catchupvideo/`,
  });
}

// Get content for the lesson
export async function getLessonContent(lessonId, params = {}) {
  return cms({
    method: "GET",
    url: `/lessons/${lessonId}/backbone/`,
    params: { ...params, is_catchup: "franchise" },
  });
}

export function getLessonList() {
  return cms({
    method: "GET",
    url: `/catchup/lessons/`,
  });
}

export async function finishLesson() {
  return cms({
    method: "POST",
    url: "/catchup/done/",
    data: {
      catchUPID: 37,
      licaoID: 74,
      percentualAcerto: 90.5,
      tentativas: 10,
      dataHora: "2019-08-26 10:20:30",
    },
  });
}

cms.interceptors.request.use(
  (config) => {
    let sessionToken = cookie.load("token_info");
    if (sessionToken) {
      const tokenType = sessionToken.token_type;
      const accessToken = sessionToken.access_token;
      config.headers["Authorization"] = tokenType + " " + accessToken;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

cms.interceptors.response.use(
  async (response) => {
    let sessionToken = cookie.load("token_info");
    if (sessionToken) {
      const tokenType = sessionToken.token_type;
      const accessToken = sessionToken.access_token;
      cms.defaults.headers.common["Authorization"] =
        tokenType + " " + accessToken;
    }

    return response.data;
  },
  async (exception) => {
    const { request = {} } = exception;
    let error = {
      status: -1,
      message: "Problemas com o servidor. Tente mais tarde. (1)",
    };

    switch (request.status) {
      case 400:
        if (exception.response.data.audio)
          error = { status: 400, message: exception.response.data.audio[0] };
        else error = { status: 400, message: "Usuário ou senha incorreta." };
        break;

      case 401:
        return refreshToken()
          .then(setToken)
          .then((data) => {
            exception.config.headers["Authorization"] =
              `${data.token_type} ${data.access_token}`;
            return cms.request(exception.config);
          });

      case 404:
        error = { status: 404, message: "Conteudo não encontrado" };
        break;

      case 500:
        error = {
          status: 500,
          message: "Problemas com o servidor. Tente mais tarde. (2)",
        };
        break;

      default:
        break;
    }

    return Promise.reject(error);
  },
);

export function setHeader(type, token) {
  if (!token) {
    throw { status: "token", message: "Token não definido" };
  }
  cms.defaults.headers.common["Authorization"] = `${type} ${token}`;
}

export function getUser(params = {}) {
  return cms({
    method: "GET",
    url: "/me/",
    params: { ...params },
  });
}

export function login(data) {
  return cms({
    method: "POST",
    url: "/oauth2old/token/",
    data: qs.stringify({
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      ...data,
    }),
  });
}

export function iesLogin(data) {
  const formData = new FormData();
  formData.append("client_id", CLIENT_ID);
  formData.append("client_secret", CLIENT_SECRET);

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return cms({
    method: "POST",
    url: "/signin/sso/ies_auth",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function iesLogout(params = {}) {
  return cms({
    method: "GET",
    url: `/signout/sso/ies_signout`,
    params: { ...params },
  });
}

/**
 * Faz a requisição dos livros.
 * @param {Object} params Paramêtros adicionais para a requisição, como o token
 */
export function getCourses(params = {}) {
  return cms({
    method: "GET",
    url: "/courses/",
    params: { ...params, is_catchup: true },
  });
}

/**
 * Faz a requisição das lições de um determinado curso.
 * @param {string} id Id do curso
 * @param {Object} params Paramêtros adicionais para a requisição, como o token.
 */
export function getLessons(id, params = {}) {
  return cms({
    method: "GET",
    url: `/courses/${id}/only-lessons-data/`,
    params: { ...params },
  });
}

export function endLesson(data) {
  return cms({
    method: "POST",
    url: "/catchup/done/",
    data: data,
  });
}

export function getScoreDataSpeechace(data) {
  return apiSpeechace({
    method: "POST",
    url: "/speechace/score",
    data: data,
  });
}

export function sendDataSpeechaceMetrics(data) {
  return apiSpeechace({
    method: "POST",
    url: "/voice-recognition/metric",
    data: data,
  });
}

export function getScoreMetricsSpeechace(user_id, id_exercise_question) {
  return apiSpeechace({
    method: "GET",
    url: `/voice-recognition/metric/user/${user_id}/exercise/${id_exercise_question}`,
  });
}

export function updateScoreMetricsSpeechace(data) {
  return apiSpeechace({
    method: "PUT",
    url: `/metric`,
    data: data,
  });
}

export function evaluatePerformance(data) {
  return apiSpeechace({
    method: "POST",
    url: "/performance",
    data: data,
  });
}

export function evaluatePerformanceORA(data, tenant) {
  if (!tenant) throw new Error("Ops!An error occurs! A tenant must be passed!");

  return apiWizSpeech({
    method: "POST",
    url: "/performance",
    data: data,
    headers: {
      tenant: tenant || "",
    },
  });
}

export function sendDataWizSpeechMetrics(data) {
  return apiWizSpeech({
    method: "POST",
    url: "/voice-recognition/metric",
    data: data,
  });
}

export function getTranslation(language) {
  return cmsNoPrefix({
    method: "POST",
    url: `taas/api/v1/wizme/${language}/`,
    data: { auth_key: TAAS_AUTH_KEY },
  });
}

export function refreshToken() {
  return getToken().then((token) =>
    login({ grant_type: "refresh_token", refresh_token: token.refresh_token }),
  );
}

export async function getToken() {
  try {
    let stringifiedToken = cookie.load("token_info");
    if (stringifiedToken === null)
      throw { status: "storage", message: "Token não existe." };
    let token = stringifiedToken;
    setHeader(token.token_type, token.access_token);
    return token;
  } catch (e) {
    throw {
      status: "storage",
      message:
        e.status === "storage" ? e.message : "Problema ao recuperar o token.",
    };
  }
}

// CORE SERVICES / DATA SERVICES ADAPTER
export function getCoursesV2(userId) {
  return selfLearningBff({
    method: "GET",
    url: `/adapter/courses/${userId}`,
    headers: {
      "x-api-key": process.env.REACT_APP_SELF_LEARNING_BFF_URL_API_KEY,
    },
  });
}
